<template>
  <div class="results-main-filter">
    <modal
      ref="xmlBeforeListModal"
      template="loading"
      title="Aguarde"
      ref-name="xmlBeforeListModal"
    >
      <p>Gerando XML...</p>
    </modal>

    <subheader
      title="Resultados - Download de XML"
      class="alternative-subheader"
    />

    <div class="results-main-filter__container">
      <results-fast-download
        ref="fastDownload"
        :days-for-statistics="daysForStatistics"
      />

      <div class="cards-filter-container__tabs">
        <div
          id="filterTab"
          class="cards-filter-container__tabs-single"
          :class="{ 'cards-filter-container__tabs-selected': tabSelected }"
          @click="changeTab(true)"
        >
          Filtrar resultados
        </div>
        <div
          id="consultTab"
          class="cards-filter-container__tabs-single"
          :class="{ 'cards-filter-container__tabs-selected': !tabSelected }"
          @click="changeTab(false)"
        >
          Consultar
        </div>
      </div>

      <div
        v-if="tabSelected"
        class="cards-filter-container__filter"
      >
        <div class="cards-filter-container__filter-field-area">
          <md-checkbox
            id="chkboxExported"
            v-model="principalFilter.exported"
            md-value="true"
            class="cards-filter-container__filter-checkbox"
          >
            Exportados
          </md-checkbox>
          <md-checkbox
            id="chkboxNotExported"
            v-model="principalFilter.notExported"
            md-value="false"
            class="cards-filter-container__filter-checkbox"
          >
            Não Exportados
          </md-checkbox>
        </div>
        <div class="cards-filter-container__filter-field-area">
          <md-checkbox
            id="chkboxNotIntegrated"
            v-model="principalFilter.integrated"
            md-value="false"
            class="cards-filter-container__filter-checkbox"
          >
            Cadastrados manualmente
          </md-checkbox>
          <md-checkbox
            id="chkboxIntegrated"
            v-model="principalFilter.notIntegrated"
            md-value="true"
            class="cards-filter-container__filter-checkbox"
          >
            Cadastradas via importação
          </md-checkbox>
        </div>
        <div class="cards-filter-container__filter-field-area">
          <md-radio
            id="radioResultDate"
            v-model="principalFilter.dateType"
            :md-value="dateTypeResultDate"
            class="cards-filter-container__filter-checkbox"
          >
            Data do resultado
          </md-radio>
          <md-radio
            id="radioRegisterDate"
            v-model="principalFilter.dateType"
            :md-value="dateTypeTransferDate"
            class="cards-filter-container__filter-checkbox"
          >
            Data de cadastro no AOL
          </md-radio>
          <div class="date-range-container">
            <p class="date-range-container-label">
              Período
            </p>
            <ap-datepicker
              ref="apDatepicker"
              :date.sync="date"
              :has-time.sync="hasTime"
              :range="true"
              placeholder="Selecione data e hora da coleta"
              :disabled-date="disablePastDates"
            />
          </div>
        </div>
        <div class="cards-filter-container__filter-field-area">
          <md-checkbox
            id="chkboxCnes"
            v-model="principalFilter.exameCNESResponsavelLiberacao"
            @change="salvarCnesNosCookies"
            md-value="false"
            class="cards-filter-container__filter-checkbox"
          >
            Retornar Cnes/Responsavel Liberação
          </md-checkbox>
        </div>
        <div class="cards-filter-container__filter-container-button">
          <md-button
            id="btnPrincipalListResults"
            class="btn btn-nonenary cards-filter-container__filter-button"
            @click="submitSearch('filter')"
          >
            <md-icon :md-src="'/static/images/icon-generate-list.svg'" />Listar Resultados
          </md-button>
          <md-button
            id="btnGetXmlResults"
            class="btn btn-primary cards-filter-container__filter-button cards-filter-container__filter-button-right"
            @click="buildParamsForXmlviaFilter()"
          >
            <md-icon md-src="/static/images/icon-download-arrow.svg" />Gerar XML
          </md-button>
        </div>
      </div>

      <div
        v-else
        class="cards-filter-container__filter"
      >
        <div class="cards-filter-container__filter-field-area">
          <div class="input-layout-container">
            <p class="input-layout-container-label">
              Paciente
            </p>
            <md-input-container>
              <md-input
                id="fieldPatient"
                v-model="consultFilter.patient"
                placeholder="Insira o nome do paciente"
              />
            </md-input-container>
          </div>
        </div>
        <div class="cards-filter-container__filter-field-area">
          <div class="input-layout-container">
            <p class="input-layout-container-label">
              <template v-if="!toggle.covax">
                OS LIS
              </template>
              <template v-else>
                Requisition Number
              </template>
            </p>
            <md-input-container>
              <md-input
                id="fieldOsLis"
                v-model="consultFilter.osLis"
                placeholder="Insira o código da OS LIS"
              />
            </md-input-container>
          </div>
        </div>
        <div class="cards-filter-container__filter-field-area">
          <div class="input-layout-container">
            <p class="input-layout-container-label">
              OS ALVARO
            </p>
            <md-input-container>
              <md-input
                id="fieldosAlvaro"
                v-model="consultFilter.osAlvaro"
                placeholder="Insira o código da OS ALVARO"
              />
            </md-input-container>
          </div>
        </div>
        <div class="cards-filter-container__filter-field-area">
          <md-radio
            id="radioResultDate"
            v-model="consultFilter.dateType"
            :md-value="dateTypeResultDate"
            class="cards-filter-container__filter-checkbox"
          >
            Data do resultado
          </md-radio>
          <md-radio
            id="radioRegisterDate"
            v-model="consultFilter.dateType"
            :md-value="dateTypeTransferDate"
            class="cards-filter-container__filter-checkbox"
          >
            Data de cadastro no AOL
          </md-radio>
          <div class="date-range-container">
            <p class="date-range-container-label">
              Período
            </p>
            <ap-datepicker
              ref="apDatepicker"
              :date.sync="date"
              :has-time.sync="hasTime"
              :range="true"
              placeholder="Selecione data e hora da coleta"
              :disabled-date="disablePastDates"
            />
          </div>
        </div>
        <div class="cards-filter-container__filter-container-button">
          <md-button
            id="btnConsultListResults"
            class="btn btn-primary cards-filter-container__filter-button"
            @click="submitSearch('consult')"
          >
            <md-icon :md-src="'/static/images/icon-generate-list.svg'" />Listar Resultados
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from '../common/SubHeader'
import DatePickerRange from '../common/DatePickerRange'
import ResultFastDownload from './FastDownload/FastDownload'
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment'
import ApDatepicker from '../apoio/ApDatepicker'
import { RESULTS_DATE_TYPE_RESULT_DATE, RESULTS_DATE_TYPE_TRANSFER_DATE, RESULTS_RECENTS_DAYS_RANGE } from '@/enums'
import { saveCookie, getCookie } from '@/utils/auth-utils'

export default {
  name: 'ResultsMainFilter',
  components: {
    subheader: SubHeader,
    'date-picker-range': DatePickerRange,
    'results-fast-download': ResultFastDownload,
    'ap-datepicker': ApDatepicker
  },
  data: () => ({
    tabSelected: true,
    principalFilter: {
      exported: '',
      notExported: 'false',
      integrated: '',
      notIntegrated: 'false',
      exameCNESResponsavelLiberacao: getCookie('resultCnes') ? getCookie('resultCnes') : false,
      dateType: RESULTS_DATE_TYPE_RESULT_DATE
    },
    consultFilter: {
      patient: '',
      osLis: '',
      osAlvaro: '',
      dateType: RESULTS_DATE_TYPE_RESULT_DATE
    },
    date: [],
    hasTime: false,
    query: '/results/list?',
    daysForStatistics: RESULTS_RECENTS_DAYS_RANGE
  }),
  computed: {
    ...mapGetters([
      'showXmlBeforeListModal',
      'getResultFilters',
      'getResultStatistictsLoadingStatus',
      'getResultStatistics',
      'profile',
      'toggle'
    ]),
    defaultStartDate: function () {
      if (this.$route.query.startDate) {
        return Moment(this.$route.query.startDate).toDate()
      } else {
        return Moment(new Date()).subtract(this.daysForStatistics, 'days').toDate()
      }
    },
    defaultEndDate: function () {
      if (this.$route.query.endDate) {
        return Moment(this.$route.query.endDate).toDate()
      } else {
        return new Date()
      }
    },
    dateTypeResultDate: function () {
      return RESULTS_DATE_TYPE_RESULT_DATE
    },
    dateTypeTransferDate: function () {
      return RESULTS_DATE_TYPE_TRANSFER_DATE
    },
    disablePastDates() {
      return date => {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        
        const compareDate = new Date(date)
        compareDate.setHours(0, 0, 0, 0)

        return compareDate > today
      }
    },
  },
  watch: {
    showXmlBeforeListModal: function (showXml) {
      if (showXml) {
        this.$refs.xmlBeforeListModal.open()
      } else {
        this.$refs.xmlBeforeListModal.close()
      }
    }
  },
  created() {
    this.getFiltersGlobally()
    this.setDefaultDate()

    this.$analytics.pushAnalyticsEvent('vpageview', {
      page: 'results/filter',
      'id-usuario': this.profile.id,
      'id-lab': this.profile.id_laboratory,
      nlab: this.profile.laboratoryName
    })
  },
  beforeDestroy() {
    this.query = '/results/list?'
  },
  methods: {
    ...mapActions([
      'exportResultByFilter',
      'updateResultFilters',
      'updateResultsStatistics',
      'resetResultsStatistics',
      'selectResultList'
    ]),
    changeTab(value) {
      this.tabSelected = value
    },
    createQuery(value) {
      let exported = this.setExportedValue()
      let origin = this.setOriginValue()
      let q = ''

      if (this.date[0] && this.date[1]) {
        this.query = this.query.concat(
          '&startDate=' + this.date[0] + '&endDate=' + this.date[1] + '&hasTime=' + this.hasTime
        )
      }

      switch (value) {
        case 'filter':
          this.query = this.query.concat('&filterByOrigin=' + origin)
          this.query = this.query.concat('&orderBy=' + exported)
          if (this.principalFilter.dateType) {
            this.query = this.query.concat('&dateType=' + this.principalFilter.dateType)
          }
          break
        case 'consult':
          if (this.consultFilter.osLis) {
            q = this.consultFilter.osLis
            q = q.replace(/[%¨!@#$&*()+=\\-_]/gi, '')
            this.query = this.query.concat('&codeOsLis=' + q)
          }
          if (this.consultFilter.patient) {
            q = this.consultFilter.patient
            q = q.replace(/[%¨!@#$&*()+=\\-_]/gi, '')
            this.query = this.query.concat('&patientName=' + q)
          }
          if (this.consultFilter.dateType) {
            this.query = this.query.concat('&dateType=' + this.consultFilter.dateType)
          }
          if (this.consultFilter.osAlvaro) {
            q = this.consultFilter.osAlvaro
            q = q.replace(/[%¨!@#$&*()+=\\-_]/gi, '')
            this.query = this.query.concat('&q=' + q)
          }
          break
      }
    },
    setExportedValue() {
      if (this.principalFilter.exported && !this.principalFilter.notExported) {
        return true
      } else if (!this.principalFilter.exported && this.principalFilter.notExported) {
        return false
      } else {
        return ''
      }
    },
    setOriginValue() {
      if (this.principalFilter.integrated && !this.principalFilter.notIntegrated) {
        return false
      } else if (!this.principalFilter.integrated && this.principalFilter.notIntegrated) {
        return true
      } else {
        return ''
      }
    },
    salvarCnesNosCookies(event) {
      console.info('salvando nos cookies', event)
      saveCookie('resultCnes', event)
    },
    submitSearch(value) {
      this.createQuery(value) 
      this.setFiltersGlobally()
      this.$router.push({ path: this.query })
      this.submitEventToAnalytics('Exibir Listagem - aba ' + value)
    },
    downloadXml() {
      this.exportResultByFilter().then(downloadLink => {
        if (downloadLink) {
          document.body.appendChild(downloadLink)
          downloadLink.click()

          let self = this
          this.resetResultsStatistics()
          this.$nextTick(function () {
            self.updateResultsStatistics(this.daysForStatistics)
          })
        }
      })
      this.setFiltersGlobally()
      this.$refs.fastDownload.closeFastDownloadModal()
    },
    getFiltersGlobally() {
      if (
        Object.keys(this.getResultFilters.principalFilter).length > 0 &&
          Object.keys(this.getResultFilters.consultFilter).length > 0
      ) {
        this.principalFilter = this.getResultFilters.principalFilter
        this.consultFilter = this.getResultFilters.consultFilter
        this.date = this.getResultFilters.date
      }
    },
    setFiltersGlobally() {
      let filterArray = {}
      filterArray.principalFilter = this.principalFilter
      filterArray.consultFilter = this.consultFilter
      filterArray.date = this.date
      this.updateResultFilters(filterArray)
    },
    buildParamsForXmlviaFilter() {
      if (!this.profile.defaulter) {
        saveCookie('resultCnes', this.principalFilter.exameCNESResponsavelLiberacao)
        this.selectResultList({
          startDate: this.date[0],
          endDate: this.date[1],
          hasTime: this.hasTime,
          exported: this.setExportedValue(),
          dateType: this.principalFilter.dateType,
          integrated: this.setOriginValue()
        })
        this.downloadXml()
      } else {
        this.$store.commit('RESULT_SET_OVERDUE', true)
      }
      this.submitEventToAnalytics('Gerar XML direto pelo filtro')
    },
    submitEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Resultados - Filtro',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    setDefaultDate() {
      this.date[0] = this.defaultStartDate
      this.date[1] = this.defaultEndDate

      if (this.$route.query.hasTime === 'true') {
        this.$nextTick(function () {
          this.$refs.apDatepicker.setCalendarToDateTimeFormat()
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/variables';

  // TO BE COMPONIZED
  .xmx-btn.xmx-datepicker-btn-confirm {
    background: #7f1a54;
    color: white;
    margin-left: 2em;

    &:hover {
      background: #691043;
      color: white;
    }
  }
  //

  .results-main-filter {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    height: 100%;

    &__container {
      flex-flow: column wrap;
      display: block;
      min-width: 670px;
    }

    &__title {
      height: 26px;
      line-height: 26px;
      text-align: left;
      color: #7a7a7a;
      font-weight: 500;
      letter-spacing: 0.8px;
      margin-left: 1em;
      font-size: 14px;
    }

    .cards-filter-container {
      display: flex;

      &__tabs {
        display: flex;
        margin-top: 10px;
        margin-left: 15px;

        &-single {
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          padding: 10px 40px 10px 40px;
          background-color: rgba(255, 255, 255, 0.5);
          margin-right: 3px;
          cursor: pointer;
          line-height: 26px;
          text-align: left;
          color: #7a7a7a;
          font-weight: 500;
          letter-spacing: 0.8px;
          font-size: 14px;
        }

        &-selected {
          background-color: white;
        }
      }

      &__filter {
        background-color: white;
        border-radius: 5px;
        border-top-left-radius: 0px;
        margin-left: 15px;
        padding: 15px;
        min-width: 500px;

        &-field-area {
          background-color: rgba(127, 26, 84, 0.1);
          padding-right: 12px;
          padding-left: 12px;
          border-radius: 5px;
          margin-bottom: 15px;
        }

        &-container-button {
          display: flex;
          justify-content: flex-end;
        }

        &-button {
          width: 48%;

          &-right {
            margin-left: 3%;
          }
        }

        .btn-nonenary {
          .md-icon {
            > svg .color {
              fill: $brand-primary;
              transition: 0.6s;
            }
          }

          &:hover .md-icon > svg .color {
            fill: white;
            transition: 0.6s;
          }
        }

        .md-input-container {
          background-color: white;
          border-radius: 5px;
          min-height: auto;
          margin: 0px;
          padding-top: 0px;
          padding-right: 10px;
          padding-left: 0;
          padding-left: 10px;

          input {
            font-weight: 400 !important;
            padding-left: 0 !important;
            letter-spacing: inherit !important;
            font-size: 14px !important;
          }
        }

        .input-layout-container,
        .date-range-container {
          display: flex;

          &-label {
            color: #7a7a7a;
            text-align: left;
            font-size: 12px;
            font-weight: 500;
            padding-top: 5px;
            padding-right: 10px;
            letter-spacing: 1px;
            text-transform: uppercase;
          }
        }
        .date-range-container {
          padding-top: 15px;
          padding-bottom: 15px;

          .search-bar__date {
            margin: 0;
          }

          .md-input-container input,
          .md-input-container textarea {
            min-width: 240px;
          }

          .md-input-container.md-has-value input,
          .md-input-container.md-has-value textarea,
          .md-input-container.md-input-focused input,
          .md-input-container.md-input-focused textarea {
            color: #7a7a7a;
            text-align: left;
            font-size: 12px;
            font-weight: 450;
            padding-left: 10px;
            letter-spacing: 1px;
          }
        }

        .date-range-container,
        .input-layout-container {
          padding-top: 7px;
          padding-bottom: 7px;

          &-label {
            justify-content: right;
            display: flex;
            width: 20%;
            white-space: normal;
            text-align: right;
          }

          .md-input-container.md-has-value input,
          .md-input-container.md-has-value textarea,
          .md-input-container.md-input-focused input,
          .md-input-container.md-input-focused textarea {
            color: #7a7a7a;
            text-align: left;
            font-size: 12px;
            font-weight: 450;
            padding-left: 10px;
            letter-spacing: 1px;
          }
        }

        .date-range-container {
          .md-input-container {
            max-width: 100%;

            &::after {
              display: none;
            }
          }
        }

        .input-layout-container {
          .md-input-container {
            max-width: 80%;
            max-height: 2.3em;
            align-self: center;

            &::after {
              display: none;
            }
          }
        }

        .md-checkbox {
          margin-right: 2em;
          margin-top: 13px;
          margin-bottom: 13px;

          .md-checkbox-container {
            background-color: white;
            border: 2px solid rgba(255, 255, 255, 1);
            border-radius: 3px;
          }
        }

        .md-theme-default.md-checkbox.md-checked .md-checkbox-container {
          background-color: $brand-primary;
          border: 2px solid $brand-primary;
        }

        .md-checkbox-label {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 500;
          padding-bottom: 10px;
          letter-spacing: 0.8px;
        }

        .md-radio {
          margin-right: 2em;

          .md-radio-container {
            background-color: white;
            border: 2px solid rgba(255, 255, 255, 1);
          }
        }

        .md-theme-default.md-radio.md-checked .md-radio-container {
          background-color: white;
          border: 2px solid white;
        }

        .md-radio-label {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 500;
          padding-bottom: 10px;
          letter-spacing: 0.8px;
        }

        .md-theme-default.md-radio .md-radio-container::after {
          background-color: $brand-primary;
        }
      }
    }
  }
</style>
